// ja.js
import elementLocale from 'element-ui/lib/locale/lang/en' // Element UI无官方日语包，暂用英文

export default {
  ...elementLocale,
  menu: {
    home: 'ホーム',
    product: '製品紹介',
    news: 'ニュースとリソース',
    about: '私たちについて',
    contact: 'お問い合わせ'
  },
  common: {
    welcome: 'ようこそ'
  }
}